import {
  FileDrop,
  Grid,
  Heading,
  IconModuleLine,
  Text,
  View,
} from "@instructure/ui";
import { t } from "i18next";
import {
  csvFileEnricher,
  fileReader,
  fileWriter,
} from "../../../utils/FileUtils";
import { ERROR, useNotification } from "../../CustomHooks/NotificationProvider";

const EnrichedFileDrop = ({
  fileState,
  setFileState,
  enriched_content,
  fileDropHeading,
  fileExtension,
  multiFileSupport,
  interaction = true,
  onFileDrop,
}) => {
  const showNotification = useNotification();

  const onDropAccepted = async (files) => {
    if (multiFileSupport) {
      setFileState(files);
    } else {
      if (files[0].type === "text/csv") {
        const fr = await fileReader(files[0]);
        const content = fr.result;
        const enrichedContent = csvFileEnricher(content, enriched_content);
        const enrichedFile = fileWriter(
          enrichedContent,
          files[0].name,
          files[0].type
        );
        setFileState(enrichedFile);
      } else {
        setFileState(files[0]);
      }
    }
  };

  return (
    <FileDrop
      accept={fileExtension}
      shouldAllowMultiple={multiFileSupport}
      onDropAccepted={(files) => {
        onDropAccepted(files);
        if (onFileDrop) {
          onFileDrop(files);
        }
      }}
      onDropRejected={() => {
        showNotification(t("notifications.invalidFileType"), ERROR);
      }}
      interaction={interaction ? "enabled" : "disabled"}
      renderLabel={
        <View as="div" padding="xx-large large" background="primary">
          <IconModuleLine size="large" />
          <Heading>{fileDropHeading}</Heading>
          <Grid>
            <Grid.Row hAlign="center">
              <Grid.Col>
                <Text color="brand">{t("ilo.dragAndDropLabel")}</Text>
              </Grid.Col>
            </Grid.Row>
            <Grid.Row hAlign="center">
              {fileState && (
                <Grid.Col>
                  {multiFileSupport ? (
                    <Text>{fileState.map((file) => file.name).join(", ")}</Text>
                  ) : (
                    <Text>{fileState.name}</Text>
                  )}
                </Grid.Col>
              )}
            </Grid.Row>
          </Grid>
        </View>
      }
    />
  );
};

export default EnrichedFileDrop;
